const strings = {
  loading: 'Deleting device...',
  success: 'Device deleted successfully',
  error: 'Failed to delete device',
};

export default strings;
